import { classify } from 'sidecar-utilities'

import { Sentiment } from '@sidecar-components/types'
import { IconSize } from '@sidecar-components/atoms/Icon'

// the mr controls the space between the icon and the text. Larger text
// will have larger icons and require a bit more space between them.
// the -top controls the vertical alignment of the icon because vertical-align
// isn't reliable enough.
const iconSpacing = {
  xxs: 'mr-1',
  xs: 'mr-1',
  sm: 'mr-1 -top-0.5',
  md: 'mr-2 -top-1',
  lg: 'mr-2 -top-1',
  xl: 'mr-3 -top-1',
  xxl: 'mr-4 -top-1',
}

export const textStyles = ({
  disabled,
  sentiment,
}: {
  disabled?: boolean
  sentiment?: Sentiment
}) => {
  // If the text is disabled, just make it grey
  if (disabled) {
    return sentiment === 'brand'
      ? 'color-textEngageOnBrand-disabled'
      : 'color-textPrimary-disabled'

    // If the text is NOT disabled, make sure there is no underline and
    // it has hover/active/focus states
  } else {
    return classify({
      base: 'no-underline hover:underline focus:underline',
      // The group is used for the icon to pick up link's state
      group: 'group/link',
      defaultColor:
        sentiment === 'brand'
          ? 'color-textEngageOnBrand-default'
          : 'color-textPrimary',
      hoverColor:
        sentiment === 'brand'
          ? 'hover:color-textOnPrimary'
          : 'hover:color-textPrimary-hover',
      activeColor:
        sentiment === 'brand'
          ? 'active:color-textOnPrimary'
          : 'active:color-textPrimary-active',
      focusColors:
        sentiment === 'brand'
          ? 'focus:color-textOnPrimary color-outlinePrimaryDecor'
          : 'focus:color-textPrimary-hover color-outlinePrimaryDecor',
      focusRing: 'ring-0 ring-offset-0',
    })
  }
}

export const iconStyles = ({
  disabled,
  iconSize,
  sentiment,
}: {
  disabled?: boolean
  iconSize?: IconSize
  sentiment?: Sentiment
}) => {
  if (disabled) {
    return classify({
      disabled:
        sentiment === 'brand'
          ? 'color-iconEngageOnBrand-disabled'
          : 'color-iconPrimary-disabled',
      spacing: iconSpacing[iconSize],
      position: 'inline-block align-middle relative',
    })
  } else {
    return classify({
      default:
        sentiment === 'brand'
          ? 'color-iconEngageOnBrand-default'
          : 'color-iconPrimary',
      hover:
        sentiment === 'brand'
          ? 'group-hover/link:color-iconEngageOnBrand-hover'
          : 'group-hover/link:color-iconPrimary-hover',
      active:
        sentiment === 'brand'
          ? 'group-active/link:color-iconEngageOnBrand-active'
          : 'group-active/link:color-iconPrimary-active',

      focus:
        sentiment === 'brand'
          ? 'group-focus/link:color-iconEngageOnBrand-hover'
          : 'group-focus/link:color-iconPrimary-hover',
      spacing: iconSpacing[iconSize],
      position: 'inline-block align-middle relative',
    })
  }
}
